import React, { useState, useRef } from "react";
import styled from "styled-components";
import Draggable from "react-draggable";
import html2canvas from "html2canvas";
import { AiOutlineFontSize, AiOutlinePicture } from "react-icons/ai";
import { FaMagic } from "react-icons/fa";
import { IoArrowBackOutline } from "react-icons/io5";
import bgImage from '../assets/bg.png';
import catImage from "../assets/cat.png";
import chapeuDePirata from "../assets/chapeu-de-pirata.png";
import flag1 from "../assets/flag_1.png";
import flag from "../assets/flag.png";
import papagaio1 from "../assets/papagaio_1.png";
import papagaio from "../assets/papagaio.png";
import tapaOlho from "../assets/tapa_olho.png";


const PageContainer = styled.div`
  padding-top: 20px;
  background-image: url(${bgImage});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  min-height: 100vh;
  font-family: "Comic Sans MS", cursive, sans-serif;
  position: relative;
  overflow-x: hidden;
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  cursor: pointer;
  margin-left: 25px;
  font-size: 1.5em;
  color: #333;
  padding: 8px 12px;
  border-radius: 50%;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
    transform: translateX(-5px);
  }
`;

const BuilderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

const UploadBox = styled.div`
  width: 500px;
  height: 500px;
  border: 2px solid rgba(222, 220, 176, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: center;
  position: relative;
  margin-bottom: 20px;
  border-radius: 15px;
  filter: ${(props) => props.filter};
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
    height: 400px;
  }
`;

const SidePanel = styled.div`
  width: 300px;
  background: rgba(153, 153, 153, 0.95);
  backdrop-filter: blur(10px);
  padding: 25px;
  margin-left: 20px;
  border-radius: 15px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 400px;
    margin-left: 0;
  }
`;

const IconMenu = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 15px;
  border-radius: 12px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 0.1);
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.5em;
  color: ${(props) => (props.active ? "#fff" : "rgba(255, 255, 255, 0.6)")};
  transition: all 0.3s ease;
  padding: 8px;
  border-radius: 8px;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }
`;

const TextOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  margin-top: 20px;
  width: 100%;

  input, select {
    width: 100%;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: rgba(255, 255, 255, 0.5);
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1);
    }
  }
`;

const ImageOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  gap: 12px;
  margin-top: 20px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
`;

const ImageThumbnail = styled.img`
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    border-color: #fff;
    transform: scale(1.1);
  }
`;

const ActionButton = styled.button`
  background-color: #333;
  color: white;
  padding: 12px 24px;
  font-size: 1em;
  margin: 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #000;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

const DeleteButton = styled(ActionButton)`
  background-color: #ff4d4f;

  &:hover {
    background-color: #ff1a1a;
  }
`;

const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0;
  gap: 10px;
`;

const SliderLabel = styled.label`
  width: 100px;
  color: white;
  font-size: 0.9em;
`;

const Slider = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  outline: none;
  opacity: 0.7;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    &:hover {
      transform: scale(1.2);
    }
  }
`;

const MemeBuilder = () => {
  const [uploadedImage] = useState(catImage);
  const memeRef = useRef();
  const [draggableItems, setDraggableItems] = useState([]);
  const [activeItemId, setActiveItemId] = useState(null);
  const [textSettings, setTextSettings] = useState({
    text: "",
    fontFamily: "Arial",
    fontSize: 20,
    textColor: "#000000",
    strokeColor: "#ffffff",
    strokeWidth: 1,
    borderColor: "#000000",
    isBold: false,
    isItalic: false,
    isUnderline: false,
  });
  const [filterSettings, setFilterSettings] = useState({
    brightness: 1,
    contrast: 1,
    grayscale: 0,
    sepia: 0,
    invert: 0,
    blur: 0,
    saturation: 1,
  });
  const [activePanel, setActivePanel] = useState("none");

  const fontOptions = ["Arial", "Comic Sans MS", "Courier New", "Georgia", "Times New Roman"];

  const generateFilter = () => {
    const { brightness, contrast, grayscale, sepia, invert, blur, saturation } = filterSettings;
    return `brightness(${brightness}) contrast(${contrast}) grayscale(${grayscale}) sepia(${sepia}) invert(${invert}) blur(${blur}px) saturate(${saturation})`;
  };

  const addText = () => {
    const newTextItem = { id: Date.now(), type: "text", ...textSettings };
    setDraggableItems([...draggableItems, newTextItem]);
    setActiveItemId(newTextItem.id);
  };

  const addImage = (src) => {
    setDraggableItems([...draggableItems, { id: Date.now(), type: "image", src }]);
  };

  const downloadMeme = () => {
    html2canvas(memeRef.current, { useCORS: true }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "meme.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  const handleTextEdit = (id, key, value) => {
    setDraggableItems((prevItems) =>
      prevItems.map((item) => (item.id === id ? { ...item, [key]: value } : item))
    );
  };

  const deleteSelectedItem = () => {
    setDraggableItems((prevItems) => prevItems.filter((item) => item.id !== activeItemId));
    setActiveItemId(null);
  };

  return (
    <PageContainer>
      
        <BackButton onClick={() => window.history.back()}>
          <IoArrowBackOutline />
        </BackButton>
      
      <BuilderContainer>
        <div>
          <UploadBox ref={memeRef} backgroundImage={uploadedImage} filter={generateFilter()}>
            {draggableItems.map((item) =>
              item.type === "text" ? (
                <Draggable key={item.id} bounds="parent" onStop={() => setActiveItemId(item.id)}>
                  <div
                    contentEditable={activeItemId === item.id}
                    suppressContentEditableWarning
                    style={{
                      fontFamily: item.fontFamily,
                      fontSize: `${item.fontSize}px`,
                      color: item.textColor,
                      fontWeight: item.isBold ? "bold" : "normal",
                      fontStyle: item.isItalic ? "italic" : "normal",
                      textDecoration: item.isUnderline ? "underline" : "none",
                      WebkitTextStroke: `${item.strokeWidth}px ${item.strokeColor}`,
                      borderColor: item.borderColor,
                    }}
                    onBlur={(e) => handleTextEdit(item.id, "text", e.target.innerText)}
                  >
                    {item.text}
                  </div>
                </Draggable>
              ) : (
                <Draggable key={item.id} bounds="parent" onStop={() => setActiveItemId(item.id)}>
                  <img src={item.src} alt="Draggable" style={{ width: "100px", borderRadius: "8px" }} />
                </Draggable>
              )
            )}
          </UploadBox>
          <div style={{ display: "flex", gap: "10px" }}>
            <ActionButton onClick={downloadMeme}>Download</ActionButton>
            <DeleteButton onClick={deleteSelectedItem}>Delete Selected</DeleteButton>
          </div>
        </div>
        <SidePanel>
          <IconMenu>
            <IconButton active={activePanel === "text"} onClick={() => setActivePanel("text")}>
              <AiOutlineFontSize />
            </IconButton>
            <IconButton active={activePanel === "image"} onClick={() => setActivePanel("image")}>
              <AiOutlinePicture />
            </IconButton>
            <IconButton active={activePanel === "effects"} onClick={() => setActivePanel("effects")}>
              <FaMagic />
            </IconButton>
          </IconMenu>

          {activePanel === "text" && (
            <TextOptions>
              <input
                type="text"
                placeholder="Enter text"
                value={textSettings.text}
                onChange={(e) => setTextSettings({ ...textSettings, text: e.target.value })}
              />
              <label>Font Family:</label>
              <select
                value={textSettings.fontFamily}
                onChange={(e) => setTextSettings({ ...textSettings, fontFamily: e.target.value })}
              >
                {fontOptions.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
              <label>Font Size:</label>
              <input
                type="range"
                min="10"
                max="100"
                value={textSettings.fontSize}
                onChange={(e) => setTextSettings({ ...textSettings, fontSize: parseInt(e.target.value) })}
              />
              <label>Text Color:</label>
              <input
                type="color"
                value={textSettings.textColor}
                onChange={(e) => setTextSettings({ ...textSettings, textColor: e.target.value })}
              />
              <label>Border Color:</label>
              <input
                type="color"
                value={textSettings.borderColor}
                onChange={(e) => setTextSettings({ ...textSettings, borderColor: e.target.value })}
              />
              <label>Stroke Color:</label>
              <input
                type="color"
                value={textSettings.strokeColor}
                onChange={(e) => setTextSettings({ ...textSettings, strokeColor: e.target.value })}
              />
              <ActionButton onClick={addText}>Add Text</ActionButton>
            </TextOptions>
          )}

          {activePanel === "image" && (
            <ImageOptions>
              {[chapeuDePirata, flag1, flag, papagaio1, papagaio, tapaOlho].map((src) => (
                <ImageThumbnail key={src} src={src} onClick={() => addImage(src)} />
              ))}
            </ImageOptions>
          )}

          {activePanel === "effects" && (
            <div>
              {Object.keys(filterSettings).map((effect) => (
                <SliderWrapper key={effect}>
                  <SliderLabel>{effect.charAt(0).toUpperCase() + effect.slice(1)}:</SliderLabel>
                  <Slider
                    type="range"
                    min={effect === "blur" ? "0" : "0"}
                    max={effect === "blur" ? "10" : "2"}
                    step="0.1"
                    value={filterSettings[effect]}
                    onChange={(e) =>
                      setFilterSettings({
                        ...filterSettings,
                        [effect]: parseFloat(e.target.value),
                      })
                    }
                  />
                </SliderWrapper>
              ))}
            </div>
          )}
        </SidePanel>
      </BuilderContainer>
    </PageContainer>
  );
};

export default MemeBuilder;
